import { revealDeckCard, topDeck } from '../../stores/cards'
import {
  handOver,
  sourceCard,
  zoomDeck,
  deckCardVisible,
  deckSelected,
  discardSelected,
} from '../../stores/cardPLay'

function computerDeckClick() {
  if (handOver()) return {}

  if (sourceCard()) return 

  const sCard = topDeck()
  sCard.displayClass = 'visible'
  sourceCard(sCard)
  zoomDeck(true)
  revealDeckCard()

  deckCardVisible(true)
  deckSelected(true)
  discardSelected(false)
}

export { computerDeckClick }
